import React, { useEffect, useRef, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import style from "../exam/ExamResult.module.css";
import "../../../assets/css/admin/allAdmins.module.css";
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import jsPDF from "jspdf";
import { useAuth } from "../../../AuthContext";
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import api from "../../../api";

const ViewStudentsDetails = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();

  const [students, setStudents] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterClass, setFilterClass] = useState("All");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalStudents, setTotalStudents] = useState(0);

  const contentRef = useRef();

  // Fetch students from backend with server-side search, filter, and pagination
  const getStudents = () => {
    api
      .get(
        `${baseUrl}/student/all?page=${page}&limit=${limit}&classFilter=${
          filterClass === "All" ? "" : filterClass
        }&searchQuery=${encodeURIComponent(searchQuery)}`
      )
      .then((res) => {
        setStudents(res.data.students);
        setTotalPages(res.data.totalPages);
        setTotalStudents(res.data.total);
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    getStudents();
  }, [page, limit, filterClass, searchQuery]);

  // PDF download function
  const downloadPDF = () => {
    const doc = new jsPDF();
    const content = contentRef.current;
    const contentWidth = content.offsetWidth;
    const contentHeight = content.offsetHeight;

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const scaleX = pageWidth / contentWidth;
    const scaleY = pageHeight / contentHeight;
    let scale = Math.min(scaleX, scaleY);
    const scaleFactor = 0.9;
    scale *= scaleFactor;

    doc.html(content, {
      callback: function (doc) {
        doc.save(`${filterClass} students details.pdf`);
      },
      x: 10,
      y: 10,
      html2canvas: { scale: scale },
    });
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    const startPage = Math.max(1, page - 2);
    const endPage = Math.min(totalPages, startPage + maxVisible - 1);

    if (startPage > 1) pages.push(1, "...");
    for (let i = startPage; i <= endPage; i++) pages.push(i);
    if (endPage < totalPages) pages.push("...", totalPages);
    return pages;
  };

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? "" : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
        <div style={{ height: "30px" }} className="position-relative">
          {isSidebarOpen ? (
            <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />
          ) : (
            <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />
          )}
        </div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to="/admin/dashboard" className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/admin/students" className="text-decoration-none">Students</Link>
              </li>
              <li className="breadcrumb-item active">View</li>
            </div>
            <li className="nav-item dropdown">
              <span className="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="" role="button" aria-expanded="false">
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: "150px" }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>Logout</span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>

        {/* Controls: PDF, Class Filter, Search, Entries per page */}
        <div className="d-flex mb-3 align-items-center gap-3">
          <button className="btn btn-success btn" onClick={downloadPDF}>Download</button>

          <div>
            <label className="mr-2 text-dark">Filter by Class: </label>
            <select
              onChange={(e) => { setFilterClass(e.target.value); setPage(1); }}
              value={filterClass}
            >
              <option value="All">All</option>
              <option value="Class XI">Class XI</option>
              <option value="Class XII">Class XII</option>
              <option value="Class XII Passed">Class XII Passed</option>
            </select>
          </div>

          <div>
            <label className="ml-3 text-dark">Search: </label>
            <input
              className="ml-2 bg-white"
              type="text"
              placeholder="Search for students here"
              value={searchQuery}
              onChange={(e) => { setSearchQuery(e.target.value); setPage(1); }}
            />
          </div>

          <div>
            <label className="ml-3 text-dark">Entries per page: </label>
            <select onChange={(e) => { setLimit(Number(e.target.value)); setPage(1); }} value={limit}>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
        </div>

        {/* Table */}
        <div className="container" style={{ backgroundColor: "white", padding: "40px" }}>
          <div ref={contentRef}>
            <div className="justify-content-center d-flex">
              <img src="/assets/images/monoarclogo.jpeg" width="320px" alt="logo" />
            </div>
            <h5 className="text-center mb-2 pb-2 pt-2" style={{ borderTop: "2px solid black", borderBottom: "2px solid black" }}>
              NEET - (Pre-Medical) {filterClass} Students Details
            </h5>

            <table className={`${style.table}`}>
              <thead>
                <tr>
                  <td>SI</td>
                  <td>Name</td>
                  <td>Father's Name</td>
                  <td>Mother's Name</td>
                  <td>Email</td>
                  <td>Contact No.</td>
                  <td>Registration Number</td>
                  <td style={{ minWidth: "110px" }}>Class</td>
                  <td style={{ minWidth: "150px" }}>Reference</td>
                </tr>
              </thead>
              <tbody>
                {students.length > 0 &&
                  students.map((a, i) => (
                    <tr key={i}>
                      <td>{(page - 1) * limit + i + 1}</td>
                      <td>{a.name}</td>
                      <td>{a.fatherName}</td>
                      <td>{a.motherName}</td>
                      <td>{a.email}</td>
                      <td>{a.contact}</td>
                      <td>{a.studentID}</td>
                      <td>{a.className}</td>
                      <td>{a.reference}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <button className="btn btn-outline-primary btn-sm" disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>

            <div className="d-flex gap-2">
              {getPageNumbers().map((p, idx) =>
                p === "..." ? (
                  <span key={idx} className="px-2">...</span>
                ) : (
                  <button
                    key={idx}
                    className={`btn btn-sm ${p === page ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => setPage(p)}
                  >
                    {p}
                  </button>
                )
              )}
            </div>

            <button className="btn btn-outline-primary btn-sm" disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
          </div>

          <div className="text-end mt-2">
            Showing {(page - 1) * limit + 1}–{Math.min(page * limit, totalStudents)} of {totalStudents} entries
          </div>
        </div>
      </main>
    </div>
  );
};

export default ViewStudentsDetails;
